<template>
  <div>
  <Page v-if="!loadSettingState.error">
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">
              <div class="header-container">
                <div class="title-header">ตั้งค่าอีเมลผู้รับความคิดเห็น</div>
              </div>
            </div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3"
              v-if="isServerError()">
              {{getErrorMessageFromErrorStatus(errorStatus)}}
            </small>
            <small class="text-success font-weight-bold mr-3"
              v-if="saveSettingState.isSaved">
              <i class="fa fa-check"></i> บันทึกแล้ว
            </small>
            <button
              type="submit"
              class="btn btn-primary"
              @click.stop="onSubmit">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="section-container">
        <Section>
          <template v-slot:section-body>
            <form @submit.prevent>
              <FormGroup>
                <h5 class="name">อีเมลผู้รับความคิดเห็น</h5>
                <input placeholder="example@hotmail.com" type="email"
                  class="form-control large-device"
                  :class="{ 'is-invalid': error.commentRecieverEmail }"
                  @keyup="validateEmail"
                  v-model="config.commentRecieverEmail">
                <div class="invalid-feedback">{{error.commentRecieverEmail}}</div>
              </FormGroup>
            </form>
          </template>
        </Section>
      </div>
    </div>
  </Page>
  <ErrorMessageSettingContainer
    v-if="loadSettingState.error"
    :error="loadSettingState.error"
    :redirectLink="'/videos'"/>
  </div>
</template>

<script>
import errorFormatter from '@/utils/errorFormatter';

import Page from '@/layouts/Page.vue';
import Section from '@/components/Section.vue';
import FormGroup from '@/components/FormGroup.vue';

import {
  loadSetting,
  updateSetting,
} from './api';
import ErrorMessageSettingContainer from './ErrorMessageSettingContainer.vue';

export default {
  components: {
    Page,
    Section,
    FormGroup,
    ErrorMessageSettingContainer,
  },
  mixins: [errorFormatter],
  data() {
    return {
      config: '',
      loadSettingState: {
        isLoading: true,
        error: null,
      },
      saveSettingState: {
        isSaving: false,
        isSaved: false,
        error: null,
      },
      errorStatus: null,
      error: {
        commentRecieverEmail: '',
      },
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      try {
        this.loadSettingState.isLoading = true;
        const response = await loadSetting();
        this.config = response.data;
        this.loadSettingState.isLoading = false;
      } catch (error) {
        this.loadSettingState.error = error.response;
        this.loadSettingState.isLoading = false;
      }
    },
    async onSubmit() {
      this.saveSettingState.isSaving = true;
      this.saveSettingState.isSaved = false;
      try {
        const settingResponse = await updateSetting(this.config);
        this.config = settingResponse.data;
        this.saveSettingState.isSaving = false;
        this.saveSettingState.isSaved = true;
      } catch (error) {
        this.errorStatus = error.response.status;
        this.saveSettingState.error = this.transformErrorData(error.response.data);
        this.saveSettingState.isSaving = false;
        this.saveSettingState.isSaved = false;
      }
    },
    getErrorMessageFromErrorStatus(status) {
      return `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${status}`;
    },
    isServerError() {
      return this.errorStatus;
    },
    validateEmail() {
      this.error.commentRecieverEmail = '';
      if (!this.config.commentRecieverEmail.match(this.mailformat) && this.config.commentRecieverEmail) {
        this.error.commentRecieverEmail = 'กรุณากรอกอีเมลให้ถูกต้อง ตัวอย่าง: example@ex.com';
      } else {
        this.error.commentRecieverEmail = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  .large-device {
    width: 50%;
  }
 }

</style>
